// App shell. КОРЕНЬ `/` — ЭТО ВХОД В ВИЗАРД (`s944.d1`): реклама ведёт прямо на адрес визарда,
// служебной странице на корне делать нечего. До cc-172 здесь стояла заглушка «v1 · сессия 1 ·
// деплой жив» — русская строка на корне англоязычного продукта (`s516.d3`), единственное
// исключение гарда кириллицы; снята вместе с исключением. `?view=wizard` остаётся тем же входом —
// на нём стоят e2e и дев-ссылки. Стенд паспорта (Track A) — `?view=passport`, вне пути человека.
//
// ⭐ ЛЮБОЙ ДРУГОЙ ПУТЬ — ЭКРАН 404 (`s951.d1`, вариант а). `vercel.json` переписывает все пути на
// приложение, чтобы дев (Vite и так отдаёт `index.html` на любой путь) и прод вели себя одинаково;
// решает, что путь чужой, приложение. Хеш и `?view=` живут на корне и этой веткой не задеваются.
//
// ⭐ `/r/{token}` — РАЗБОР ПО ССЫЛКЕ ИЗ ПИСЬМА (Supabase, часть 1, п. 4; `ReadingPage.jsx`). Своим путь
// считается только с токеном правильной формы (`TOKEN_RE`): `/r/`, `/r/abc` — по-прежнему 404.
//
// ⭐ `/begin` — ВТОРОЙ АДРЕС ВИЗАРДА (`s956.d3`): корень отходит лендингу Life Map (вёрстка — свой
// тикет), визард переезжает сюда. Пока лендинга нет, корень остаётся визардом — оба адреса ведут в
// один и тот же визард. Вход с лендинга — `/begin?from=landing` (см. `router.js`, `LANDING_PARAM`).

import PassportDev from './render/PassportDev.jsx';
import DocFitStand from './render/DocFitStand.jsx';
import ReadingPage from './reading/ReadingPage.jsx';
import { tokenFromPath } from './share/snapshot.js';
import { NotFound } from './wizard/StubScreen.jsx';
import { stepNumber } from './wizard/address.js';
import { WizardProvider } from './wizard/WizardProvider.jsx';
import WizardShell from './wizard/WizardShell.jsx';
import StepFive from './wizard/steps/StepFive.jsx';
import StepSix from './wizard/steps/StepSix.jsx';
import StepSeven from './wizard/steps/StepSeven.jsx';
import StepFour from './wizard/steps/StepFour.jsx';
import StepOne from './wizard/steps/StepOne.jsx';
import StepThree from './wizard/steps/StepThree.jsx';
import StepTwo from './wizard/steps/StepTwo.jsx';

/**
 * Пути, которые принадлежат приложению: корень, `/index.html` (тот же документ под своим именем) и
 * `/begin` (`s956.d3`; с косой на конце — тот же адрес, его допишет кто угодно руками) и разбор по
 * ссылке `/r/{token}`. Всё прочее — `/foo`, `/s3/2`, будущие `/p/…` до своего тикета — чужое.
 */
const APP_PATHS = new Set(['/', '/index.html', '/begin', '/begin/']);

export function isAppPath(pathname) {
  return APP_PATHS.has(pathname) || tokenFromPath(pathname) !== null;
}

function view() {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get('view');
}

/**
 * ЕДИНСТВЕННАЯ ТОЧКА ВХОДА ЭКРАНОВ В ОБОЛОЧКУ (`renderStep` у `WizardShell`).
 *
 * ⚠️ ЭКСПОРТИРУЕТСЯ РАДИ ТЕСТОВ НАМЕРЕННО. Приёмка B3-2 требует, чтобы тест экрана ходил ЧЕРЕЗ
 * проводку, а не мимо неё: смонтировать `<StepOne />` напрямую значит проверить компонент и
 * ничего не сказать о том, показывает ли его оболочка на первом шаге. До B3-2 проп не
 * передавался нигде вовсе — ни в коде, ни в тестах, — и был машинно не покрыт.
 *
 * `null` — честное «экрана нет»: оболочка покажет заглушку с адресом. С B8-3 у всех семи шагов есть
 * экран, и `null` остаётся только на адресе вне 1–7. (До B5-2 заглушка стояла на «3–7», до B6-3 — на
 * «4–7», до B7-3 — на «5–7», до B9-3 — на «6–7», до B8-3 — на шаге 6: экраны приезжали по одному, шаг 7
 * пришёл раньше шага 6.)
 *
 * ⚠️ ВТОРОЙ АРГУМЕНТ — АДРЕС ПЕЧАТАЕМОГО ЭКРАНА, а не поле конверта. В состоянии входа
 * (`s895.d1`) они расходятся намеренно: конверт помнит `s4/2/b`, а на экране лендинг. Выбирать
 * экран по `session.step` значило бы показать в состоянии 2 четвёртый шаг. Умолчание оставлено
 * ради вызовов в один аргумент — вне оболочки расхождения нет.
 */
export function renderStep(session, address = session.step) {
  if (stepNumber(address) === 1) return <StepOne />;
  // ⚠️ ЭКРАН ШАГА 2 АДРЕС ПРОПОМ НЕ ПОЛУЧАЕТ, И ЭТО НЕ ЭКОНОМИЯ СТРОКИ. Ему нужен не только
  // номер шага, но и номер ряда из `#s2/3`, а ряды лежат в конверте — то есть он всё равно
  // идёт в `useWizard()`. Взять адрес оттуда же (`view`) значит иметь ОДИН источник, а не два
  // полусогласованных: проп и контекст разошлись бы ровно в состоянии входа (`s895.d1`).
  if (stepNumber(address) === 2) return <StepTwo />;
  // ⚠️ ШАГ 3 АДРЕС ПРОПОМ ТОЖЕ НЕ ПОЛУЧАЕТ, И ПРИЧИНА ТА ЖЕ, ЧТО У ШАГА 2, только сильнее: ему
  // нужен не номер шага, а КАРТОЧКА и ПАНЕЛЬ из `#s3/2/b`, плюс ряды этапов из конверта. Оба
  // приезжают через `useWizard()`, и брать номер шага пропом значило бы иметь два источника
  // одного адреса — они разошлись бы в состоянии входа (`s895.d1`).
  if (stepNumber(address) === 3) return <StepThree />;
  // Шаг 4 (B6-3) — та же схема: экрану нужны ряды и ползунки конверта, и берёт он их из
  // `useWizard()`, а не пропом.
  if (stepNumber(address) === 4) return <StepFour />;
  // Шаг 5 (B7-3) — та же схема: паспорт экран собирает из конверта сам.
  if (stepNumber(address) === 5) return <StepFive />;
  // Шаг 6 (B8-3) — overlay в статике: паспорт экран собирает из конверта сам, как шаг 5.
  if (stepNumber(address) === 6) return <StepSix />;
  // Шаг 7 (B9-3) — gated: паспорт для миниатюры обложки экран собирает из конверта сам.
  if (stepNumber(address) === 7) return <StepSeven />;
  return null;
}

export default function App() {
  // Раньше провайдера: он на старте пишет конверт и правит адрес, а на чужом пути ему делать нечего.
  if (typeof window !== 'undefined' && !isAppPath(window.location.pathname)) return <NotFound />;
  const reading = typeof window !== 'undefined' ? tokenFromPath(window.location.pathname) : null;
  if (reading) return <ReadingPage token={reading} />;

  const current = view();
  if (current === 'passport') return <PassportDev />;
  // стенд гарда перелива паспорта (s969) — читает tests/e2e/passport-docfit.spec.js
  if (current === 'docfit') return <DocFitStand />;

  // Всё, что не стенд паспорта, — визард: и голый корень `/`, и дев-маршрут `?view=wizard`
  // (`s944.d1`, отменяет «заглушку на `/` не трогаем» из `s894`).
  return (
    <WizardProvider>
      <WizardShell renderStep={renderStep} />
    </WizardProvider>
  );
}
